<template>
  <div class="product-block-inner step-one">

    <span class="product-block-span step-one-top-margin">
      <h1 v-html="title"></h1>
      <h3 v-html="subtitle"></h3>

      <!-- FLOATING LOGOS -->
      <div class="hero-commerce-logos">
        <span :class="`social-logo ${logo}-social-logo ${logoClass(index)}`" v-for="(logo, index) in commerceLogos">
          <img :src="getSocialImageUrl(logo)">
        </span>
      </div>

      <div class="hero-social-logos">
        <span :class="`social-logo ${logo}-social-logo ${logoClass(index)}`" v-for="(logo, index) in socialLogos">
          <img :src="getSocialImageUrl(logo)">
        </span>
      </div>

      <DemoButton :buttonMessage="'Software, Use Attach'"></DemoButton>
    </span>

    <span class="product-block-span step-one-images animated">

      <img class="phone-image player-attach-content" src="../../../../assets/winter-2019/hero-phone-16.png">
      <video class="phone-image-inner" src="https://s3.amazonaws.com/attach-videos/XMpqlCjT82Cgip0hnQF1_attach_anywhere_sm.mov" muted playsinline autoplay loop></video>

      <img class="macbook-image player-attach-content" src="../../../../assets/winter-2019/hero-macbook-1.png">
      <video class="macbook-image-inner" src="https://attach-videos.s3.amazonaws.com/eWkquuN0R1K6Y5BYB2JA_attach_anywhere_desktopV3.mp4" muted playsinline autoplay loop></video>

    </span>

  </div>
</template>

<script>

import logos from '../logos'

import DemoButton from './GetDemoButton'

export default {
  data() {
    return {
      title: 'Make all of your media shoppable with any eRetailer, anywhere.',
      subtitle: 'With hundreds of retailer integrations, and compatability with any platform & device, you can use Attach to make any media shoppable.',
      socialLogos: logos.social,
      commerceLogos: logos.commerce
    }
  },
  components: {
    DemoButton
  },
  mounted() {},
  methods: {
    logoClass(index) {
      return index % 2 == 0 ? 'even-class' : 'odd-class'
    },
    getSocialImageUrl(name) {
      var images = require.context('../../../../assets/social-logos/')
      return images(`./${name}.png`)
    },
    getPlayerLink(playerId) {
      return `https://multicart-dev.mikmak.tv/${playerId}?internalVisualTest=true&cb=3251&buildView=true`
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .product-block-inner {
    display: flex;
    margin: 24px auto;
    padding: 0px 15%;
    overflow: hidden;
    min-height: 600px;
  }

  .product-block-span {
    display: inline-block;
    width: 50%;
    text-align: left;
  }

  .product-block-span h1 {
    font-size: 32px;
    font-family: "Work Sans", sans-serif;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 34px;
  }

  .product-block-span h3 {
    font-size: 18px;
    font-weight: normal;
    font-family: "Work Sans", sans-serif;
  }

  @media only screen and (max-width: 1000px) {
    .product-block-inner {
      display: block;
      min-height: 850px;
    }

    .product-block-span {
      display: block;
      width: 100%;
      text-align: center;
    }

    .product-block-span h1 {
      font-size: 24px;
    }

    .product-block-span h3 {
      max-width: 400px;
      margin: 0 auto;
      margin-bottom: 32px;
    }
  }

  .social-logo {
    background: white;
    height: 36px;
    width: 36px;
    display: inline-block;
    border-radius: 100px;
    padding: 8px;
    border: 4px solid #f3f3f3;
  }

  .social-logo img {
    display: block;
    width: 36px;
  }

  .odd-class {
    margin-bottom: -24px;
    margin-right: -24px;
    margin-left: -24px;
  }

  @media only screen and (max-width: 1200px) {
    .odd-class {
      margin-right: -24px;
      margin-left: -24px;
    }
  }

  @media only screen and (max-width: 800px) {
    .odd-class {
      margin-right: -30px;
      margin-left: -30px;
    }
  }

  @media only screen and (max-width: 800px) {
    .product-block-inner {
      padding: 12px;
      min-height: 300px;
      margin-top: 48px;
    }

    .hero-social-logos {
      text-align: center;
      margin-bottom: 32px;
    }
  }

  /* Component Specific */

  .step-one-top-margin {
    margin-top: 80px;
  }

  .phone-image {
    position: absolute;
    width: 370px;
    z-index: 4;
    height: 660px;
  }

  .phone-image-inner {
    position: absolute;
    width: 367px;
    z-index: 3;
    margin-top: -36px;
    border: none;
    -ms-transform: scale(0.7);
    transform: scale(0.7);
    background-color: white;
  }

  .macbook-image {
    position: absolute;
    width: 658px;
    z-index: 2;
    margin-left: 181px;
    margin-top: 120px;
  }

  .macbook-image-inner {
    position: absolute;
    z-index: 1;
    margin-left: -220px;
    margin-top: -70px;
    border: none;
    -ms-transform: scale(0.4);
    transform: scale(0.4);
    height: 772px;
    clip-path: inset(0px 125px 0px 0px);
  }

  @media only screen and (max-width: 1000px) {

    .step-one-images {
      text-align: center;
    }

    .step-one-top-margin {
      max-width: 90%;
      margin: 0 auto;
    }

    .phone-image {
      width: 200px;
      height: 370px;
      position: relative;
      margin-left: -200px;
    }

    .phone-image-inner {
      margin-top: -153px;
      margin-left: -276px;
      width: 352px;
      height: 631px;
      transform: scale(0.4);
    }

    .macbook-image {
      width: 300px;
      margin-left: -66px;
      margin-top: 76px;
    }

    .macbook-image-inner {
      width: 907px;
      margin-left: -380px;
      margin-top: -64px;
      transform: scale(0.3);
      height: 456px;
    }
  }

  .demo-button {
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    color: #fff;
    font-size: 22px;
    text-decoration: none;
    cursor: pointer;
    min-width: 224px;
    max-width: 300px;
    text-align: center;
    padding: 8px;
    border-radius: 3px;
    margin: 48px 0px;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 6px #00000024;
    font-weight: lighter;
    text-decoration: none;
    letter-spacing: 1px;
    border: none;
  }


  .hero-commerce-logos {

  }

</style>



// WEBPACK FOOTER //
// StepUseAttachAnywhere.vue?1bc5f69d